<div class="p-4">
  <h3>Affaire liées</h3>
  @if (isProjectLocked()) {
  <div class="alert alert-warning mb-4">
    Projet verrouillé (VALIDE/TERMINE): l'affaire ne peut plus être modifiée.
  </div>
  }
  @if (readonlyMode) {
  <div class="alert alert-warning mb-4">
    Vous n'avez pas les droits pour modifier l'affaire du projet.
  </div>
  }
  @if (localErrorMessage()) {
  <div class="alert alert-error mb-4">{{ localErrorMessage() }}</div>
  }
  @if (successMessage()) {
  <div class="alert alert-success mb-4">{{ successMessage() }}</div>
  }

  <div class="form-group mb-4" *ngIf="!readonlyMode">
    <label>AFFAIRE</label>
    <div class="dropdown-select" (click)="$event.stopPropagation()">
      <button type="button" class="select-btn" (click)="toggleAffaireDropdown()"
        [disabled]="isSaving() || isProjectLocked()">
        {{ displaySelectedAffaire() }}
        <span class="caret">▾</span>
      </button>
      <div class="dropdown-panel" *ngIf="showAffaireDropdown()">
        <input type="text" class="dropdown-search" placeholder="Rechercher une affaire..."
          (input)="onAffaireSearchChange($any($event.target).value)">
        <div class="options-list">
          @for (a of affaireOptions(); track a.id) {
          <div class="option-item" (click)="selectAffaire(a)">
            <div class="option-title">{{ a.numeroAffaire }}</div>
            <div class="option-sub">{{ a.client.denomination }}</div>
          </div>
          } @empty {
          <div class="empty-option">Aucune affaire trouvée</div>
          }
        </div>
        <button type="button" class="load-more" (click)="loadMoreAffaires()"
          [disabled]="affairePage() + 1 >= affaireTotalPages() || isLoadingAffaires()">
          {{ isLoadingAffaires() ? 'Chargement...' : (affairePage() + 1 < affaireTotalPages() ? 'Charger plus'
            : 'Fin de liste' ) }} </button>
      </div>
    </div>
  </div>
  <div class="affaire-list-container">
    <label class="mb-2 d-block">AFFAIRE LIÉE AU PROJET</label>
    <div class="affaire-grid">
      @if (selectedAffaire(); as a) {
      <div class="affaire-card">
        <div class="affaire-card-header">
          <div class="affaire-name">{{ a.numeroAffaire }}</div>
          <button type="button" class="btn-remove-affaire" (click)="detachAffaire()"
            [disabled]="isSaving() || isProjectLocked()" *ngIf="!readonlyMode" title="Détacher">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="affaire-card-body">
          <div class="affaire-info-item">
            <span class="label">Client:</span>
            <span class="value">{{ a.client.denomination }}</span>
          </div>
          <div class="affaire-info-item">
            <span class="label">Date création:</span>
            <span class="value">{{ a.dateCreation | date:'dd/MM/yyyy' }}</span>
          </div>
          <div class="mt-3">
            <a [routerLink]="['/affaires/edit', a.id]" class="btn-link-affaire">
              <mat-icon>visibility</mat-icon>
              Voir la fiche affaire
            </a>
          </div>
        </div>
      </div>
      } @else {
      <div class="empty-list-message">
        <mat-icon>info_outline</mat-icon>
        <p>Aucune affaire n'est actuellement liée à ce projet.</p>
      </div>
      }
    </div>
  </div>

  @if (showConfirmDelete()) {
  <app-confirm-dialog title="Détacher l'affaire"
    message="Êtes-vous sûr de vouloir détacher cette affaire de ce projet ?" (confirmed)="confirmDetachAffaire()"
    (cancelled)="cancelDetachAffaire()">
  </app-confirm-dialog>
  }
</div>